import { isDevMode } from '@angular/core';
import {
  ActionReducer,
  ActionReducerMap,
  createFeatureSelector,
  createSelector,
  MetaReducer,
} from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { toastReducer, ToastState } from './reducers/toast.reducer';
import {
  settingsReducer,
  SettingsReducerInitialState,
} from './reducers/settings.reducer';
import { lookupReducer, LookupState } from './reducers/lookup.reducer';
import { decrypt, encrypt } from '../utils/crypt';
import {
  factoryReducer,
  FactoryReducerInitialState,
} from './reducers/factory.reducer';

export interface AppState {
  toast: ToastState;
  settings: SettingsReducerInitialState;
  lookup: LookupState;
  factory: FactoryReducerInitialState;
}

export const reducers: ActionReducerMap<AppState> = {
  toast: toastReducer,
  settings: settingsReducer,
  lookup: lookupReducer,
  factory: factoryReducer,
};

export function localStorageSyncReducer(
  reducer: ActionReducer<AppState>
): ActionReducer<AppState> {
  return localStorageSync({
    keys: [
      {
        settings: {
          encrypt: (state) => encrypt(state),
          decrypt: (state) => decrypt(state),
        },
      },
      {
        factory: {
          encrypt: (state) => encrypt(state),
          decrypt: (state) => decrypt(state),
        },
      },
    ],
    rehydrate: true,
  })(reducer);
}

export const metaReducers: MetaReducer<AppState>[] =
  typeof window === 'undefined'
    ? []
    : isDevMode()
    ? [localStorageSyncReducer]
    : [localStorageSyncReducer];
